module.exports = __webpack_public_path__ + "media/Video 83.8caab364.mp4";